import Vue from 'vue'
// 按需导入组件
import {
  CountDown,
  Toast,
  Overlay,
  Button,
  Checkbox,
  CheckboxGroup,
  ActionSheet,
  Field,
  RadioGroup,
  Radio,
} from "vant";

// 注册全局组件
Vue.use(CountDown);
Vue.use(Toast)
Vue.use(Overlay)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(ActionSheet)
Vue.use(Field)
Vue.use(Radio);
Vue.use(RadioGroup);